/**
 * User: Shad
 * Date: 9/4/13
 */
"use strict";
var SoaModel = require('bunsen/models/SoaModel');
var AdjustmentList = SoaModel.extend();

module.exports = AdjustmentList;

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var Adjustment = require('bunsen/models/ecomm/Adjustment.js');
var getAdjustmentsTotalByfn;
var getAdjustmentsByFn;


getAdjustmentsTotalByfn = function (fn, currency) {
    return _.reduce(getAdjustmentsByFn.call(this, fn), function (memo, adjustment) {
        return memo + (parseFloat(adjustment.getTotalAmount(currency)) || 0);
    }, 0, this);
};

getAdjustmentsByFn = function (fn) {
    if (!this.get('documents')) {
        return [];
    }
    return this.get('documents').filter(function (adjustment) {
        return adjustment[fn]();
    });
};
/**
 * @class AdjustmentList
 * @extends SoaModel
 * @property {array} relations
 *      @property relations.type {Backbone.One}
 *      @property relations.key {string}- "item"
 *      @property relations.relatedModel {Backbone.Model}
 *      @property relations.collectionType {Backbone.Models}
 */
_.extend(AdjustmentList.prototype, {
    relations: [{
        type: Backbone.Many,
        key: 'documents',
        relatedModel: Adjustment
    }],
    getMerchTaxTotal: _.partial(getAdjustmentsTotalByfn, 'isMerchTaxAdjustment'),
    getShippingTaxTotal: _.partial(getAdjustmentsTotalByfn, 'isShippingTaxAdjustment'),
    getCommissionTotal: _.partial(getAdjustmentsTotalByfn, 'isCommissionAdjustment'),
    getProcessingFeeTotal: _.partial(getAdjustmentsTotalByfn, 'isProcessingFeeAdjustment'),
    getListingCreditTotal: _.partial(getAdjustmentsTotalByfn, 'isListingCreditAdjustment'),
    getComplimentaryShippingTotal: _.partial(getAdjustmentsTotalByfn, 'isComplimentaryShipping'),
    getDealerChargeTotal: _.partial(getAdjustmentsTotalByfn, 'isDealerCharge'),
    getPromotionTotal: _.partial(getAdjustmentsTotalByfn, 'isPromotionAdjustment'),
    hasPromotion: function () {
        return !!getAdjustmentsByFn.call(this, 'isPromotionAdjustment').length;
    },
    getListingCreditAdjustment: function () {
        return getAdjustmentsByFn.call(this, 'isListingCreditAdjustment')[0];
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/AdjustmentList.js
// module id = 55
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56